

import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  templateUrl: './confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class ConfirmationModalComponent {
  isOpen = input.required<boolean>();
  title = input<string>('Are you sure?');
  message = input.required<string>();
  confirmButtonText = input<string>('Confirm');
  confirmButtonClass = input<string>('bg-red-600 hover:bg-red-700');
  cancelButtonText = input<string>('common.cancel');

  confirm = output<void>();
  cancel = output<void>();

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onBackdropClick(event: MouseEvent): void {
      if (event.target === event.currentTarget) {
          this.onCancel();
      }
  }
}